import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-windowPattern",
  "use": "icon-windowPattern-usage",
  "viewBox": "0 0 1536 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1536 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-windowPattern\"><defs><style></style></defs><path d=\"M0 0h896v128H0V0zm0 640h896v128H0V640zm0-384h896v128H0V256zm0 640h896v128H0V896zm1152-256h384v384h-384V640zm128 128v128h128V768h-128zM1152 0h384v384h-384V0zm128 128v128h128V128h-128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol